module.exports = __webpack_public_path__ + "static/img/banner3.c8554d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 26